import React, { createContext, useContext, useState } from 'react';

const AuthReadyContext = createContext({ authReady: false, setAuthReady: () => {} });

export const useAuthReady = () => useContext(AuthReadyContext);

export const AuthReadyProvider = ({ children }) => {
  const [authReady, setAuthReady] = useState(false);
  return (
    <AuthReadyContext.Provider value={{ authReady, setAuthReady }}>
      {children}
    </AuthReadyContext.Provider>
  );
};
